import * as React from 'react'
import {
  Edit,
  NumberField,
  SimpleForm,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  NumberInput,
  TopToolbar,
  ListButton,
  TextField,
} from 'react-admin'

import { useGetIdentity } from 'react-admin'
import * as PropTypes from 'prop-types'
import { Typography, Box } from '@material-ui/core'

const CoregEditActions = ({ identity, basePath }) => {
  let countryBasePath = ''
  if (identity.role !== 'admin') {
    countryBasePath = `${basePath}?filter={"country":"${identity.country}"}`
  }
  return (
    <TopToolbar>
      <ListButton basePath={countryBasePath} />
    </TopToolbar>
  )
}

CoregEditActions.propTypes = {
  basePath: PropTypes.any,
  identity: PropTypes.any,
}

const CoregsEdit = props => {
  const { identity, loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  const country = identity.country
  const questionSource = 'label.' + country.toLowerCase()
  return (
    <Edit actions={<CoregEditActions identity={identity} />} {...props}>
      <SimpleForm>
        <Box mb={2}>
          <Typography variant="body2" color="textSecondary">
            Modifica la configuracion del corregistro y su estado de envio.
          </Typography>
        </Box>
        <NumberField source="id" disabled />
        <ReferenceInput
          translateChoice={false}
          label="Question"
          source="questionId"
          reference="questions"
        >
          <SelectInput optionText={questionSource} fullWidth />
        </ReferenceInput>
        <NumberInput label="CD Affiliate" source="cdAffiliateId" disabled />
        <NumberInput label="CD Campaign" source="cdCampaignId" />
        <BooleanInput source="status" />
        <TextField source="country" disabled />
      </SimpleForm>
    </Edit>
  )
}

export default CoregsEdit
